import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CONGRESS_CONTAINER_CONVERTER_TOKEN, CongressContainerConverter } from './congress-container.component.converter'
import {
  CONGRESS_CONTAINER_NARROW_TWO_COLUMNS_CONVERTER_TOKEN, CongressContainerNarrowTwoColumnsConverter
} from './congress-container-narrow-two-columns/congress-container-narrow-two-columns.component.converter'
import {
  CONGRESS_CONTAINER_NARROW_THREE_COLUMNS_CONVERTER_TOKEN, CongressContainerNarrowThreeColumnsConverter
} from './congress-container-narrow-three-columns/congress-container-narrow-three-columns.component.converter'
import {
  CONGRESS_CONTAINER_ICON_AND_TEXT_CONVERTER_TOKEN, CongressContainerIconAndTextConverter
} from './congress-container-icon-and-text/congress-container-icon-and-text.component.converter'
import {
  CONGRESS_CONTAINER_ICON_ABOVE_TEXT_CONVERTER_TOKEN, CongressContainerIconAboveTextConverter
} from './congress-container-icon-above-text/congress-container-icon-above-text.component.converter'
import {
  CONGRESS_CONTAINER_HEADLINE_CONVERTER_TOKEN, CongressContainerHeadlineConverter
} from './congress-container-headline/congress-container-headline.component.converter'
import {
  CONGRESS_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN, CongressContainerContentTextConverter
} from './congress-container-content-text/congress-container-content-text.component.converter'
import {
  CONGRESS_CONTAINER_CONTACT_INFO_CONVERTER_TOKEN, CongressContainerContactInfoConverter
} from './congress-container-contact-info/congress-container-contact-info.component.converter'
import {
  CONGRESS_CONTAINER_AGENDA_ITEM_CONVERTER_TOKEN, CongressContainerAgendaItemConverter
} from './congress-container-agenda-item/congress-container-agenda-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        congressContainerFeature: {
          module: () => import('./congress-container.module').then((m) => m.CongressContainerModule),
          cmsComponents: ['congresscontainer']
        },
      },
    }),
    {
      provide: CONGRESS_CONTAINER_CONVERTER_TOKEN,
      useExisting: CongressContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        congresscontainer: CONGRESS_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_NARROW_TWO_COLUMNS_CONVERTER_TOKEN,
      useExisting: CongressContainerNarrowTwoColumnsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        narrow_two_columns: CONGRESS_CONTAINER_NARROW_TWO_COLUMNS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_NARROW_THREE_COLUMNS_CONVERTER_TOKEN,
      useExisting: CongressContainerNarrowThreeColumnsConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        narrow_three_columns: CONGRESS_CONTAINER_NARROW_THREE_COLUMNS_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_ICON_AND_TEXT_CONVERTER_TOKEN,
      useExisting: CongressContainerIconAndTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        icon_and_text: CONGRESS_CONTAINER_ICON_AND_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_ICON_ABOVE_TEXT_CONVERTER_TOKEN,
      useExisting: CongressContainerIconAboveTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        icon_above_text: CONGRESS_CONTAINER_ICON_ABOVE_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_HEADLINE_CONVERTER_TOKEN,
      useExisting: CongressContainerHeadlineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        congresscontainerelementheadline: CONGRESS_CONTAINER_HEADLINE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN,
      useExisting: CongressContainerContentTextConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        congresscontainerelementcontenttext: CONGRESS_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_CONTACT_INFO_CONVERTER_TOKEN,
      useExisting: CongressContainerContactInfoConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        congresscontainerelementcontactinfo: CONGRESS_CONTAINER_CONTACT_INFO_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: CONGRESS_CONTAINER_AGENDA_ITEM_CONVERTER_TOKEN,
      useExisting: CongressContainerAgendaItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        congresscontainerelementagendaitem: CONGRESS_CONTAINER_AGENDA_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ],
})
export class CongressContainerFeatureModule {}
